import { Dashboard } from '@mui/icons-material';
import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { UserSettingsCard } from '~/scenes/PortalModules/User/UserSettings/components/UserSettingsCard';
import { useWorkspaceHomepageCard } from '~/scenes/PortalModules/User/UserSettings/components/WorkspaceHomepageCard/useWorkspaceHomepageCard';

export const WorkspaceHomepageCard = () => {
  const { t } = useTranslation();

  const {
    form: {
      control,
      formState: { isDirty },
    },
    editMode,
    onEdit,
    onCancelEdit,
    onSubmit,
    isLoading,
    isWorkspaceEnabled,
  } = useWorkspaceHomepageCard();

  if (!isWorkspaceEnabled) {
    return null;
  }

  return (
    <UserSettingsCard
      Icon={Dashboard}
      title={t('laSetWorkspaceAsHomepage')}
      loading={isLoading}
      actions={
        editMode ? (
          <>
            <Button size="small" onClick={onCancelEdit}>
              {t('laCancel')}
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={onSubmit}
              disabled={!isDirty}
            >
              {t('laSave')}
            </Button>
          </>
        ) : (
          <Button size="small" onClick={onEdit}>
            {t('laEdit')}
          </Button>
        )
      }
    >
      <Controller
        control={control}
        name={'useWorkspaceAsHomepage'}
        render={({ field: { value, onChange } }) => {
          return editMode ? (
            <FormControl>
              <RadioGroup
                value={value ? 'yes' : 'no'}
                onChange={(e) => onChange(e.target.value === 'yes')}
                row
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio size="small" />}
                  label={t('laYes')}
                />
                <FormControlLabel
                  value="no"
                  control={<Radio size="small" />}
                  label={t('laNo')}
                />
              </RadioGroup>
            </FormControl>
          ) : (
            <Typography variant={'body2'}>
              {value ? t('laYes') : t('laNo')}
            </Typography>
          );
        }}
      />
    </UserSettingsCard>
  );
};
